<template>

    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#803BB9" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Toast />
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                </Breadcrumb>
            </div>
            <div class="col-12 lg:col-12 xl:col-12">
                <div class="card">
                    <div class="col-12 lg:col-12 xl:col-12">
                        <div class="p-fluid formgrid grid" style="margin-top: 1%">

                            <div class="field col-12 md:col-2">
                                <span class="p-float-label">
                                    <InputText type="text" v-model="search_aaplication_name"></InputText>
                                    <label for="name">Applicant Name</label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-2">
                                <span class="p-float-label">
                                    <InputText type="text"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="10"
                                        v-model="search_aaplication_mobile"></InputText>
                                    <label for="name">Mobile</label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-2">
                                <span class="p-float-label">
                                    <Dropdown id="User" filter v-model="state_dropdownItem"
                                        :options="state_dropdownItems" optionLabel="name"
                                        :value="state_dropdownItems.value" @change="getDistrictData" display="chip">
                                    </Dropdown>
                                    <label for="complaint_status">State</label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-2">
                                <span class="p-float-label">
                                    <Dropdown id="User" filter v-model="district_dropdownItem"
                                        :options="district_dropdownItems" optionLabel="name"
                                        @change="getMuncipalCorporationData" display="chip">
                                    </Dropdown>
                                    <label for="complaint_status">District</label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-2">
                                <span class="p-float-label">
                                    <Dropdown id="User" filter v-model="mcorporation_dropdownItem"
                                        :options="mcorporation_dropdownItems" optionLabel="name" display="chip">
                                    </Dropdown>
                                    <label for="complaint_status">Muncipal Corporation</label>
                                </span>
                            </div>

                            <div class="field col-12 md:col-2">
                                <Button icon="pi pi-search" @click="search(1)" v-tooltip.bottom="'Search'" /> &nbsp;
                                <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Reset'" />
                            </div>

                        </div>
                    </div>

                    <DataTable :loading="loading" ref="dt" size="small" :lazy="true" :totalRecords="totalRecords"
                        :paginator="true" :value="products" :v-model:selection="selectedProducts" :dataKey="columns[0]"
                        :rows="limit" :filters="filters" @page="onPage($event)"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[5, 10, 25, totalRecords]"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        responsiveLayout="scroll" showGridlines :rowHover="true"><template #empty>
                            <b style="text-align: center">No records found.</b>
                        </template>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0"><b>New Application List</b></h5>
                                <div>
                                    <Button icon="pi pi-download" class="p-button-help" @click="exportCSV($event)"
                                        v-tooltip.bottom="'Download'" />
                                    <!-- <Button icon="pi pi-download" class="p-button-help" @click="generatePDF()"
                                        v-tooltip.bottom="'Download'" /> -->
                                    <br>
                                    <p>Total : {{ totalRecords }}</p>
                                </div>
                            </div>
                        </template>
                        <Column header="No" style="min-width: 2rem; text-align: center">
                            <template #body="{ index }">
                                <span v-if="page_no == 1">{{ +index + +1 }}</span>
                                <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
                            </template>
                        </Column>
                        <Column header="Status" style="min-width: 3rem" :field="columns[0]" class="md:col-2">
                            <template #body="{ data }">
                                <span
                                    v-if="data.application_status_name == 'Approved' || data.application_status_name == 'approved'">
                                    <badge :value=data.application_status_name severity="success"></badge>
                                </span>
                                <span
                                    v-else-if="data.application_status_name == 'Applied' || data.application_status_name == 'applied'">
                                    <badge :value=data.application_status_name severity="warning"></badge>
                                </span>
                                <span
                                    v-else-if="data.application_status_name == 'Rejected' || data.application_status_name == 'rejected'">
                                    <badge :value=data.application_status_name severity="danger"></badge>
                                </span>
                                <span
                                    v-else-if="data.application_status_name == 'Incomplete' || data.application_status_name == 'Incomplete'">
                                    <badge :value=data.application_status_name severity="danger"></badge>
                                </span>
                                <!------Clerk-->
                            <span v-else-if="data.application_status_name == 'Pending By Clerk' || data.application_status_name == 'Pending By Clerk'">
                                <badge :value="data.application_status_name" severity="primary"></badge>
                            </span>
                            <span v-else-if="data.application_status_name == 'Rejected By Clerk' || data.application_status_name == 'Rejected By Clerk'">
                                <badge :value="data.application_status_name" severity="danger"></badge>
                            </span>

                             <span v-else-if="data.application_status_name == 'Approved By Clerk' || data.application_status_name == 'Approved By Clerk'">
                                <badge :value="data.application_status_name" severity="success"></badge>
                            </span>
                            <!--------Senior Clerk-->
                             <span v-else-if="data.application_status_name == 'Approved By Senior Clerk' || data.application_status_name == 'Approved By Senior Clerk'">
                                <badge :value="data.application_status_name" severity="success"></badge>
                            </span>
                             <span v-else-if="data.application_status_name == 'Rejected By Senior Clerk' || data.application_status_name == 'Rejected By Senior Clerk'">
                                <badge :value="data.application_status_name" severity="danger"></badge>
                            </span>

                            <span v-else-if="data.application_status_name == 'Pending By Senior Clerk' || data.application_status_name == 'Pending By Senior Clerk'">
                                <badge :value="data.application_status_name" severity="primary"></badge>
                            </span>
                            <!-----commissioner-->
                            <span v-else-if="data.application_status_name == 'Approved By Secretary' || data.application_status_name == 'Approved By Secretary'">
                                <badge :value="data.application_status_name" severity="success"></badge>
                            </span>
                               <span v-else-if="data.application_status_name == 'Rejected By Secretary' || data.application_status_name == 'Rejected By Secretary'">
                                <badge :value="data.application_status_name" severity="danger"></badge>
                            </span>
                            
                             <span v-else-if="data.application_status_name == 'Pending By Secretary' || data.application_status_name == 'Pending By Secretary'">
                                <badge :value="data.application_status_name" severity="primary"></badge>
                            </span>
                                <span v-else>{{ data.application_status_name }}</span>
                            </template>
                        </Column>

                        <Column header="Company Name" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ data.company_name }}
                            </template>
                        </Column>
                        <Column header="Applicant Name" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ data.applicant_name }}
                            </template>
                        </Column>
                        <Column header="Applicant Mobile No" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ data.applicant_mobile_number }}
                            </template>
                        </Column>
                        <Column header="State" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ data.State_name }}
                            </template>
                        </Column>
                        <!-- <Column header="District" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ data.State_name }}
                            </template>
                        </Column> -->
                        <!-- <Column header="Muncipal Corporation" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ data.MunicipalCorporation }}
                            </template>
                        </Column> -->
                        <Column header="Applicantion Date" style="min-width: 3rem" :field="columns[0]">
                            <template #body="{ data }">
                                {{ dateFormatDMY(data.application_date) }}
                            </template>
                        </Column>
                        <Column headerStyle="min-width:5rem;">
                            <template #body="slotProps">
                                <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                                    @click="viewProduct(slotProps.data)" />

                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
import BreadcrumbService from "../service/BreadcrumbService";
export default {
    data() {
        return {
            state_dropdownItems: [],
			state_dropdownItem: null,
			district_dropdownItems: [],
			district_dropdownItem: null,
			mcorporation_dropdownItems: [],
			mcorporation_dropdownItem: null,
            user_roll_id: "",
            search_aaplication_name: "",
            search_aaplication_mobile: "",
            breadcrumbHome: {},
            breadcrumbItems: [],
            BreadcrumbService: null,

            page_no: 1,
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            file_attachment: "",
            products: null,
            productDialog: false,
            deleteProductDialog: false,
            lazyParams: {},
            product: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            limit: 10,
            columns: [],
            pageno: 1,
            submitted: false,
            totalRecords: 0,
            id: "",
        };
    },
    productService: null,
    async created() {
        this.productService = new ProductService();
        this.initFilters();
        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.getBreadcrum("New Application", "/NewApplicationList")
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;
        this.getStateData();
		this.getDistrictData();
		this.getMuncipalCorporationData();
    },
    async mounted() {
        // this.productService.getProducts().then(data => this.products = data);
        this.id = this.$route.params.id;
        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            await this.get_count();
        }
        await this.get_list();
        //alert(this.id);
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                // await this.get_count();
                // this.get_list();
            }
        },
    },
    methods: {
        getStateData() {
			this.state_dropdownItems=[];
			var data = {};
			// return false;
			this.loading = true;
			var promise = apis.StateList(data);
			promise.then((response) => {
				this.loading = false;
				if (response.data.data) {
					var temp_data = [];
					for (let x = 0; x < response.data.data.length; x++) {
						temp_data.push({
							name: response.data.data[x].State_name,
							value: response.data.data[x].State_id,
						});
					}
					this.state_dropdownItem = null;
					this.state_dropdownItems = temp_data;
				}
			});
		},
		getDistrictData() {
			this.district_dropdownItems=[];
			var state_id ="";
			if (this.state_dropdownItem) {
				var state_id = this.state_dropdownItem.value;
			}
			var data = {
				state_id: state_id
			};
			// return false;
			this.loading = true;
			var promise = apis.DistrictList(data);
			promise.then((response) => {
				this.loading = false;
				if (response.data.data) {
					var temp_data = [];
					for (let x = 0; x < response.data.data.length; x++) {
						temp_data.push({
							name: response.data.data[x].name,
							value: response.data.data[x].DistrictID,
						});
					}
					this.district_dropdownItem = null;
					this.district_dropdownItems = temp_data;
				}
			});
		},
		getMuncipalCorporationData() {
			this.mcorporation_dropdownItems=[];
			var district_id ="";
			if (this.district_dropdownItem) {
				var district_id = this.district_dropdownItem.value;
			}
			var data = {
				district_id:district_id
			};
			// return false;
			this.loading = true;

			var promise = apis.MuncipalCorporationList(data);
			promise.then((response) => {
				this.loading = false;
				if (response.data.data) {
					var temp_data = [];
					for (let x = 0; x < response.data.data.length; x++) {
						temp_data.push({
							name: response.data.data[x].MunicipalCorporation,
							value: response.data.data[x].id,
						});
					}
					this.mcorporation_dropdownItem = null;
					this.mcorporation_dropdownItems = temp_data;
				}
			});
		},
        async generatePDF() {
            const dataTable = this.$refs.dt.$el;
            const canvas = await html2canvas(dataTable);
            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF({
                orientation: "landscape",
                unit: "px",
                format: [canvas.width, canvas.height],
            });

            // pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
            pdf.save("datatable.pdf");
        },
        async search(count) {
            if (count == 2) {
                this.search_aaplication_name = "";
                this.search_aaplication_mobile = "";
                this.state_dropdownItem=null;
                this.district_dropdownItem=null;
                this.mcorporation_dropdownItem=null;
            }
            await this.get_list();
            await this.get_count();
        },
        dateFormatYMD(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;

                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);

                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return year + "-" + month + "-" + date;
                    }
                }
            }
            else {
                return "";
            }
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;

                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);

                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return date + "-" + month + "-" + year;
                    }
                }
            }
            else {
                return "";
            }
        },
        //a simple date formatting function
        dateFormat(inputDate, info) { },
        handleFileUpload() {
            this.file_attachment = this.$refs.file_attachment.files[0];
            //alert(this.$refs.file_attachment.files[0].name);
        },
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            // console.log(event);
            // await this.get_count();
            if (this.totalRecords > 0) {
                this.get_list();
            }
        },
        get_count: function () {
            var state = "";
			var district = "";
			var muncipal = "";

			if (this.state_dropdownItem) {
				state = this.state_dropdownItem.value;
			}
            else{
        state = localStorage.getItem('StateID')?localStorage.getItem('StateID'):'';
      }

			if (this.district_dropdownItem) {
				district = this.district_dropdownItem.value;
			}
            else{
        district = localStorage.getItem('DistrictID')?localStorage.getItem('DistrictID'):'';
      }

			if (this.mcorporation_dropdownItem) {
				muncipal = this.mcorporation_dropdownItem.value;
			}
            else{
        muncipal = localStorage.getItem('Municipal_CorporationID')?localStorage.getItem('Municipal_CorporationID'):'';
      }
            var data = {
                count: true,
                // application_status: 1,
                applicant_name: this.search_aaplication_name,
                MobileNo: this.search_aaplication_mobile,
                state_id:state,
				DistrictID:district,
				Municipal_CorporationID:muncipal,
            };
            this.loading = true;
            var promise = apis.NewApplicationList(data, this.id);
            promise.then((response) => {
                this.loading = false;
                // console.log(response);
                this.totalRecords = response.data.total;
                //alert(this.totalRecords);
            });
            // console.log(data);
        },
        get_list: function () {
            var state = "";
			var district = "";
			var muncipal = "";

			if (this.state_dropdownItem) {
				state = this.state_dropdownItem.value;
			}
            else{
        state = localStorage.getItem('StateID')?localStorage.getItem('StateID'):'';
      }

			if (this.district_dropdownItem) {
				district = this.district_dropdownItem.value;
			}
            else{
        district = localStorage.getItem('DistrictID')?localStorage.getItem('DistrictID'):'';
      }

			if (this.mcorporation_dropdownItem) {
				muncipal = this.mcorporation_dropdownItem.value;
			}
            else{
        muncipal = localStorage.getItem('Municipal_CorporationID')?localStorage.getItem('Municipal_CorporationID'):'';
      }
            var data = {
                limit: this.limit,
                page_no: this.page_no,
                count: false,
                // application_status: 1,
                applicant_name: this.search_aaplication_name,
                MobileNo: this.search_aaplication_mobile,
                state_id:state,
				DistrictID:district,
				Municipal_CorporationID:muncipal,
            };
            this.loading = true;
            var promise = apis.NewApplicationList(data, this.id);
            promise.then((response) => {
                this.loading = false;
                // console.log(response);
                this.products = response.data.data;
                console.log("Applicatios", this.products);
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });
            // console.log(data);
        },
        formatCurrency(value) {
            if (value)
                return value.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                });
            return;
        },
        openNew() {
            this.product = {};
            this.submitted = false;
            this.productDialog = true;
        },
        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        saveProduct() {
            this.submitted = true;
            if (this.product.id) {
                //
            } else {
                //
            }
            this.productDialog = false;
            this.product = {};
        },
        editProduct(product) {
            this.file_attachment = "";
            this.product = { ...product };
            this.productDialog = true;
        },
        async viewProduct(product) {
            this.file_attachment = "";
            this.product = { ...product };
            localStorage.setItem("applicationdata", JSON.stringify(this.product));
            localStorage.setItem("surveydata", JSON.stringify(this.product.application_details));
            localStorage.setItem("flag", 1);
            this.$router.push({ name: "ApplicationApproval", params: product });
        },
        confirmDeleteProduct(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        exportCSV() {
            this.$refs.dt.exportCSV();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    components: {},
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>